import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { SmsMessage, SmsProvider } from '../../communication.constants';
import { filter, map } from 'rxjs/operators';
import { ScheduledMessage, ScheduledMessageApiResponseData } from '../../models/scheduled-message';

@Injectable({
  providedIn: 'root',
})
export class MessagesService {
  private smsProviders$ = new BehaviorSubject<SmsProvider[]>(null);
  private smsVariables = {};

  constructor(private http: HttpClient) {
    this.http.get<SmsProvider[]>('communication/sms/providers').subscribe((providers) => {
      this.smsProviders$.next(providers);
    });
  }

  /**
   * Get all members from API
   */
  getSmsProviders(): Observable<SmsProvider[]> {
    return this.smsProviders$.pipe(filter((providers) => !!providers));
  }

  scheduleSms(messages: SmsMessage[], provider: SmsProvider, date?: Date) {
    return this.http.post('communication/sms/schedule', {
      messages,
      provider: provider.id,
      date,
    });
  }

  scheduleBroadcastSms(to: string[], message: string, provider: SmsProvider, date?: Date) {
    return this.http.post('communication/sms/broadcast/schedule', {
      to,
      message,
      provider: provider.id,
      date,
    });
  }
  ListScheduledSmsAction;
  /**
   * Get all members from API
   */
  getScheduledMessages(): Observable<any> {
    return this.http
      .get<ScheduledMessageApiResponseData[]>('communication/messages/scheduled')
      .pipe(map((messages) => messages.map((message) => new ScheduledMessage(message))));
  }

  /**
   * Get all members from API
   */
  getPendingEmail(): Observable<any> {
    return this.http.get('communication/email/pending');
  }

  sendDeviceSms(to: string | string[], message: string) {
    window.open(`sms:${Array.isArray(to) ? to.join(',') : to}?body=${message}`);
  }

  removeMessages(ids: number[]): Observable<any> {
    return this.http.delete('communication/messages', { body: ids });
  }
}
